import { render, staticRenderFns } from "./main-influence.vue?vue&type=template&id=4fa508c2&scoped=true&"
import script from "./main-influence.vue?vue&type=script&lang=js&"
export * from "./main-influence.vue?vue&type=script&lang=js&"
import style0 from "./main-influence.vue?vue&type=style&index=0&id=4fa508c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa508c2",
  null
  
)

export default component.exports